<div class="entity-config-page container-fluid px-0 py-0 py-lg-1">
  <div class="entity-config-shell d-flex flex-column gap-1 mx-auto">
    <section class="entity-config-top rounded-4 overflow-hidden shadow-sm">
      <div class="entity-config-top-hero px-2 px-md-2 py-2">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">Upload Template</h1>
            <p class="entity-page-subtitle text-white mb-0">
              Add and preview new document templates before making them available across the platform.
            </p>
          </div>

          <div class="col-auto d-flex justify-content-end">
            <div class="d-flex d-sm-inline-flex">
              <button
                type="button"
                class="btn btn-light entity-action-btn btn-sm rounded-small shadow-sm fw-semibold d-inline-flex align-items-center justify-content-center px-2 py-1 border-0 text-white text-nowrap"
                @click="go_back"
              >
                <i class="bi bi-arrow-left me-2 text-white"></i>
                Back to Templates
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="px-2 px-md-2 pb-2">
        <section class="row entity-config-top-metrics g-3 g-xl-4 align-items-stretch">
          <div class="col-12 col-lg-7 mt-2">
            <div class="card border border-purple border-opacity-50 shadow-sm rounded-4 overflow-hidden h-100">
              <div class="card-header bg-white border-bottom py-3">
                <p class="fw-bold mb-0 text-x">Template Details</p>
              </div>

              <div class="card-body text-xs">
                <div class="mb-3">
                  <label for="template_name" class="form-label fw-bold">Template name</label>
                  <input
                    type="text"
                    class="form-control text-xs"
                    id="template_name"
                    placeholder="Tax Clearance Certificate"
                    v-model.trim="template_name"
                  />
                </div>

                <div class="mb-3">
                  <label for="template_description" class="form-label fw-bold">Template Description</label>
                  <input
                    type="text"
                    class="form-control text-xs"
                    id="template_description"
                    placeholder="Proof that the supplier is in good standing with the tax authority."
                    v-model.trim="template_description"
                  />
                </div>

                <div class="mb-3">
                  <label for="template_type" class="form-label fw-bold">Template type</label>
                  <select id="template_type" v-model="selected_template_type" class="form-select text-xs">
                    <option value="" disabled hidden>Select template type</option>
                    <option v-for="type in template_types" :key="type.value" :value="type.value">
                      {{ type.label || type.template_type || type.value }}
                    </option>
                  </select>
                </div>

                <div class="mb-3">
                  <label for="template_file" class="form-label fw-bold">Upload template (PDF)</label>
                  <input
                    class="form-control text-xs"
                    type="file"
                    id="template_file"
                    accept="application/pdf,.pdf"
                    @change="handle_file_selection"
                  />
                  <div v-if="selected_file && selected_file.name" class="text-secondary text-xs mt-2">
                    Selected: {{ selected_file.name }}
                  </div>
                </div>

                <div class="d-flex justify-content-end gap-2">
                  <button type="button" class="btn btn-light btn-sm shadow-sm text-xs" @click="reset_upload_form" :disabled="upload_loading">
                    Clear
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary-dark btn-sm shadow-sm text-xs"
                    @click="upload_template"
                    :disabled="upload_loading || !template_name || !template_description || !selected_template_type || !selected_file"
                  >
                    <span v-if="!upload_loading">Save</span>
                    <span v-else class="d-inline-flex align-items-center gap-2">
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Uploading...
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-5 mt-2">
            <div class="card border border-purple border-opacity-50 shadow-sm rounded-4 overflow-hidden h-100">
              <div class="card-header bg-white border-bottom py-3">
                <p class="fw-bold mb-0 text-x">Preview</p>
              </div>
              <div class="card-body">
                <div v-if="preview_url">
                  <div v-if="is_previewable" class="ratio ratio-4x3">
                    <iframe :src="preview_url" class="w-100 h-100" frameborder="0" title="Template preview"></iframe>
                  </div>
                  <div v-else class="text-secondary text-xs">Preview unavailable for this file type.</div>
                </div>
                <div v-else class="text-secondary text-x">
                  Select a PDF file to see a preview here.
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
</div>
